export const masterReducer = {
  static: false,
};
